import React, { useEffect, useState } from 'react';
import { Menu, X } from 'lucide-react';
import { Button } from './ui/Button';
export function Navbar() {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);
  const navLinks = [{
    name: 'Home',
    href: '#home'
  }, {
    name: 'About Us',
    href: '#about'
  }, {
    name: 'Activities',
    href: '#activities'
  }, {
    name: 'News',
    href: '#news'
  }, {
    name: 'Contacts',
    href: '#contact'
  }];
  return <nav className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${isScrolled ? 'bg-[#0f5f5f] shadow-lg py-3' : 'bg-transparent py-6'}`} data-id="element-146">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-147">
        <div className="flex justify-between items-center" data-id="element-148">
          {/* Logo */}
          <div className="flex items-center space-x-3" data-id="element-149">
            <div className="w-10 h-10 rounded-full bg-[#d4a74a] flex items-center justify-center text-[#0f5f5f] font-serif font-bold text-xl" data-id="element-150">
              FG
            </div>
            <span className="text-white font-serif font-bold text-lg md:text-xl tracking-wide" data-id="element-151">
              Fair Gaming Space NGO
            </span>
          </div>

          {/* Desktop Navigation */}
          <div className="hidden md:flex items-center space-x-8" data-id="element-152">
            {navLinks.map(link => <a key={link.name} href={link.href} className="text-white/90 hover:text-[#d4a74a] font-medium text-sm uppercase tracking-wider transition-colors" data-id="element-153">
                {link.name}
              </a>)}
            <Button variant="primary" size="sm" onClick={() => document.getElementById('support')?.scrollIntoView({
            behavior: 'smooth'
          })} data-id="element-154">
              Support Us
            </Button>
          </div>

          {/* Mobile Menu Button */}
          <div className="md:hidden" data-id="element-155">
            <button onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)} className="text-white hover:text-[#d4a74a] transition-colors" data-id="element-156">
              {isMobileMenuOpen ? <X size={28} data-id="element-157" /> : <Menu size={28} data-id="element-158" />}
            </button>
          </div>
        </div>
      </div>

      {/* Mobile Menu Overlay */}
      {isMobileMenuOpen && <div className="md:hidden absolute top-full left-0 right-0 bg-[#0f5f5f] border-t border-white/10 shadow-xl" data-id="element-159">
          <div className="flex flex-col px-4 py-6 space-y-4" data-id="element-160">
            {navLinks.map(link => <a key={link.name} href={link.href} onClick={() => setIsMobileMenuOpen(false)} className="text-white hover:text-[#d4a74a] font-medium text-lg py-2 border-b border-white/5" data-id="element-161">
                {link.name}
              </a>)}
            <div className="pt-4" data-id="element-162">
              <Button variant="primary" className="w-full" onClick={() => {
            setIsMobileMenuOpen(false);
            document.getElementById('support')?.scrollIntoView({
              behavior: 'smooth'
            });
          }} data-id="element-163">
                Support Us
              </Button>
            </div>
          </div>
        </div>}
    </nav>;
}